module.exports = "/images/4_04e17e.png";